/* globals Stripe */

import { merge } from 'lodash'

import themeVars from '@/assets/styles/variables.scss'
import payments from '@/services/payments'
import config from '@/services/config'

// eslint-disable-next-line new-cap
const stripe = Stripe(config.stripeKey)
let card = null

const elements = stripe.elements({
  locale: 'en',
  fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:400' }]
})

function createCardField(element, additionalOptions = {}) {
  if (!card) {
    card = elements.create(
      'card',
      merge(
        {
          iconStyle: 'solid',
          style: {
            base: {
              'iconColor': themeVars['color-icons'],
              'color': themeVars['color-copy'],
              'fontWeight': themeVars['weight-regular'],
              'fontFamily': themeVars['font-primary'],
              'fontSize': themeVars['size-medium'],
              'fontSmoothing': 'antialiased',
              '::placeholder': { color: themeVars['color-copy-light'] },
              ':-webkit-autofill': { color: themeVars['color-fields'] }
            },
            invalid: {
              iconColor: themeVars['color-danger'],
              color: themeVars['color-danger']
            }
          }
        },
        additionalOptions
      )
    )
  }

  card.mount(element)
  return card
}

function createSource({ name, isDefault }) {
  const additionalData = {
    owner: { name }
  }

  return stripe.createSource(card, additionalData).then(function ({ source }) {
    if (!source) {
      throw new Error('Please review that your credit card details are ok.')
    }

    const { id, created, owner, status, type, usage } = source
    return payments.addStripePaymentMethod({
      id,
      card: source.card,
      // eslint-disable-next-line camelcase
      client_secret: source.client_secret,
      created,
      owner,
      status,
      type,
      usage,
      isDefault
    })
  })
}

export default {
  createCardField,
  createSource
}
